import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { supabase } from '../lib/supabaseClient';

export default function BusinessAuthCallback() {
  const { t } = useTheme();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let done = false;
    const finish = () => { if (!done) { done = true; navigate('/biz/orgs', { replace: true }); } };

    supabase.auth.getSession().then(({ data }) => {
      if (data.session) finish();
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) finish();
    });

    const timeout = setTimeout(() => {
      if (!done) setError('Sign-in is taking longer than expected. Please try again.');
    }, 8000);

    return () => { sub.subscription.unsubscribe(); clearTimeout(timeout); };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: t.pageBg, color: t.textPrimary }} data-testid="business-auth-callback-page">
      {error ? (
        <div className="text-center">
          <p className="text-sm mb-3" style={{ color: '#F59E0B' }} data-testid="business-auth-callback-error">{error}</p>
          <a href="/biz/login" className="text-sm underline" style={{ color: t.accent }}>Back to sign in</a>
        </div>
      ) : (
        <p className="text-sm" style={{ color: t.textMutedNew }}>Finishing sign-in…</p>
      )}
    </div>
  );
}
